//#region src/transactions/resolution-utils.ts
function transactionUsesGasCoin(transactionData) {
	let usesGasCoin = false;
	transactionData.mapArguments((arg) => {
		if (arg.$kind === "GasCoin") usesGasCoin = true;
		return arg;
	});
	return usesGasCoin;
}
//#endregion
export { transactionUsesGasCoin };

//# sourceMappingURL=resolution-utils.mjs.map